import { render, staticRenderFns } from "./AnswerEmoji.vue?vue&type=template&id=f5886d5c&"
import script from "./AnswerEmoji.vue?vue&type=script&lang=js&"
export * from "./AnswerEmoji.vue?vue&type=script&lang=js&"
import style0 from "./AnswerEmoji.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports